import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/projects'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  getSingle: SingleParamEndpointConstructor
  getLevels: SingleParamEndpointConstructor
  create: NoParamEndpointConstructor
  update: SingleParamEndpointConstructor
  remove: SingleParamEndpointConstructor
  getTypes: NoParamEndpointConstructor
  getFeatureFlags: NoParamEndpointConstructor
  getForecastDriversCatalog: NoParamEndpointConstructor
  getProjectForecastDrivers: SingleParamEndpointConstructor
  updateProjectForecastDrivers: SingleParamEndpointConstructor
  uiVisibility: SingleParamEndpointConstructor
}

export const projectsEndpoints: Endpoints = {
  getAll: () => `${baseUrl}`,
  getSingle: (id) => `${baseUrl}/${id}`,
  getLevels: (id) => `${baseUrl}/${id}/master-data/product/levels `,
  create: () => `${baseUrl}`,
  update: (id) => `${baseUrl}/${id}`,
  remove: (id) => `${baseUrl}/${id}`,
  getTypes: () => '/project-types',
  getFeatureFlags: () => '/feature-flags',
  getForecastDriversCatalog: () => '/forecast-drivers',
  getProjectForecastDrivers: (id) => `${baseUrl}/${id}/forecast-drivers`,
  updateProjectForecastDrivers: (id) => `${baseUrl}/${id}/forecast-drivers`,
  uiVisibility: (id) => `${baseUrl}/${id}/ui-visibility`,
}
